module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('operator-selector', {
    attrs: {
      "enableNot": _vm.enableNot,
      "enableMinus": _vm.enableMinus
    },
    on: {
      "select": _vm.selectOperator
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cdd7eab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/builderComponents/OperatorPopover.vue
// module id = 1907
// module chunks = 0